import { isNil } from 'lodash-es'
import { default as React, FunctionComponent } from 'react'

import { tDefaults, tEntries } from '../../../infrastructure/internationalisation'
import { Formatter } from '../types'

export const BooleanListFormatter: FunctionComponent<
  Formatter<Record<string, boolean>>
> = ({ value, t, input: { name } }) => {
  if (isNil(value)) {
    return <>{t(tDefaults('inputs.none'))}</>
  }

  return (
    <>
      {Object.entries(value)
        .map(([key, value]) => {
          const formattedName = t([tEntries(name, 'formatted', key), tEntries(name, key)])
          const formattedValue = value
            ? t(tEntries('boolean.yes'))
            : t(tEntries('boolean.no'))
          return `${formattedName} ${formattedValue}`
        })
        .join('\n')}
    </>
  )
}
